<template>
  <div class="uptphone">
    <b>输入短信验证码</b>
    <p style="margin-bottom: 0.55rem">
      验证码已发送至您的手机
      <span>
        {{ mobile.slice(0, 3) }}&nbsp;{{ mobile.slice(3, 7) }}&nbsp;{{ mobile.slice(7, 11) }}
      </span>
    </p>
    <div class="codeWrap" v-show="imgCodeWrapFlag">
      <div class="inputWrap">
        <input
          placeholder="图形验证码"
          maxlength="4"
          v-model="imgCodeValue"
          @keyup="imgCodeChange"
        />
        <img
          class="del-btn"
          src="../../assets/images/close.png"
          v-if="imgCodeFlag"
          @click="clearImgCode"
        />
      </div>
      <div class="codeImg" ref="codeImg" @click="getCodeImg">
        <img :src="codeImg" />
      </div>
    </div>
    <security-code v-model="authCode" :code="authCode" :type="typeFa" :number="num"></security-code>
    <i class="countdown" v-if="time != 0">{{ time }}s后重新发送</i>
    <i class="countdown sendAgain" v-else-if="time == 0" @click="sendAgain">重新发送</i>
    <!--<button class="secuCode">获取验证码</button>-->
  </div>
</template>

<script>
import securityCode from '../common/securityCode'
import { unencryption, basepath, random_string } from '../../assets/common/js/config'
export default {
  name: 'authCode',
  components: {
    securityCode
  },
  data() {
    return {
      authCode: '',
      time: 60,
      typeFa: 'security',
      num: 6,
      mobile: unencryption(sessionStorage.getItem('ckys_wx_bound_tel')),
      areaCode: '86',
      imgCodeValue: '',
      imgCodeFlag: false,
      codeImg: '',
      imgCodeWrapFlag: false
    }
  },
  mounted: function () {
    this.countdown()
    this.getCodeImg()
  },
  destroyed() {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    authCode: function (n) {
      if (n.length >= this.num) {
        this.checkPhone()
        this.login()
      }
    }
  },
  methods: {
    // 获取图形验证码
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg = this.$ajax.getValidateCode_URL(
        'sessionid=' + this.timeout + '&width=' + width + '&height=' + height
      )
    },
    // 检测图形验证码-值改变
    imgCodeChange() {
      this.imgCodeFlag = !!this.imgCodeValue
      this.checkInfo()
    },
    // 检测手机号、图形验证码长度
    checkInfo: function () {
      this.passFlag = this.imgCodeValue.length == 4
    },
    clearImgCode() {
      this.imgCodeValue = ''
      this.imgCodeFlag = false
      this.checkInfo()
    },
    code() {
      this.mobile = unencryption(sessionStorage.getItem('ckys_wx_bound_tel'))
      var type = 2
      var area_code = sessionStorage.getItem('ckys_wx_bound_area_code')
      var url =
        this.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        this.mobile +
        '&code=' +
        this.imgCodeValue +
        '&sessionid=' +
        this.timeout +
        '&type=' +
        type +
        '&area_code=' +
        area_code
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.time = 60
          that.countdown()
        } else if (res.data.code == '10011') {
          this.clearImgCode()
          this.getCodeImg()
        }
      })
    },
    login() {
      var that = this
      var url = this.$ajax.smsCodeVerify_URL + '?mobile=' + this.mobile + '&code=' + this.authCode
      var boundurl = this.$ajax.updateMeMobile_URL
      var data = {
        mobile: this.mobile
      }
      if (that.checkPhone()) {
        that.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200) {
            that.$customRequestAjax.post(boundurl, data).then((res) => {
              if (res.data.code === 200) {
                sessionStorage.setItem(
                  'ckys4_mobile',
                  unencryption(sessionStorage.getItem('ckys_wx_bound_tel'))
                )
                sessionStorage.removeItem('ckys_wx_bound_tel')
                sessionStorage.removeItem('ckys_wx_bound_area_code')
                this.$router.replace('/setting')
              }
            })
          } else {
            this.authCode = ''
          }
        })
      }
    },
    countdown: function () {
      var that = this
      var timer = setInterval(function () {
        that.time--
        if (that.time <= 0) {
          that.time = 0
          if (!that.imgCodeWrapFlag) {
            that.imgCodeWrapFlag = true
          }
          clearInterval(timer)
        }
      }, 1000)
    },
    sendAgain: function () {
      if (!this.passFlag) {
        this.$toast('请先输入图片验证码')
        return
      }
      this.code()
    },
    checkPhone: function () {
      if (!/[0-9A-Za-z]{4,6}$/.test(this.authCode)) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.uptphone {
  flex: 1;
  background: #fff;
  padding: 0.38rem 0.3rem 0;
  p {
    font-size: 0.14rem;
    color: #888888;
    line-height: 0.22rem;
    margin-top: 0.03rem;
    span {
      color: #333333;
    }
  }
  b {
    display: block;
    font-size: 29px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 41px;
  }
  .countdown {
    font-size: 0.12rem;
    color: #adadad;
    font-style: normal;
    display: block;
    margin-top: 0.19rem;
    &.sendAgain {
      color: #4a90e2;
    }
  }
  .codeWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.15rem;
    .inputWrap {
      flex: 1 1 0%;
      position: relative;
      border-radius: 0.22rem;
      padding-left: 0.15rem;
      height: 0.44rem;
      line-height: 0.44rem;
      background: #f7f7f7;
      font-size: 0.16rem;
      color: #000;
      input {
        background: none;
        outline: none;
        border: none;
      }
      .del-btn {
        width: 0.13rem;
        height: 0.13rem;
        position: absolute;
        top: 0;
        right: 0;
        margin: 0.15rem 0.09rem;
      }
    }
    .codeImg {
      height: 0.36rem;
      width: 34.5%;
      background: rgb(238, 238, 238);
      margin-left: 0.1rem;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/phone/boundPhoneCode.vue